/**
 * Hard cap the graph backends apply to a "raw" request (`reduce = 0`): trackermanager and
 * gatewaymanager `GraphDataReduction.MAX_RAW_POINTS`. Mirrored here only for the toolbar label.
 */
export const GRAPH_MAX_RAW_POINTS = 20_000;

export type GraphReduceLabel = 'reduced' | 'rawCapped' | null;

/**
 * Which toolbar hint to show next to a graph: `reduced` when the user asked for N points and got
 * a percentage of the range, `rawCapped` when the user asked for raw data but the backend still
 * capped it (an LTTB pass at {@link GRAPH_MAX_RAW_POINTS}), `null` when everything is displayed
 * or nothing was loaded (`pct` 0 is the error/empty value).
 */
export function graphReduceLabel(reduce: number, pct: number): GraphReduceLabel {
  if (pct <= 0 || pct >= 100) return null;
  return reduce === 0 ? 'rawCapped' : 'reduced';
}
